import { object, string } from "yup";
import { defaultContextFields, hospital } from "../../shared.js";
export const h2Part1DataSchema = object({
    ...defaultContextFields({
        userAddressOptional: true,
    }),
    hospital: hospital,
    registeredNurseIn: string()
        .required("Please select the option which applies")
        .default(null),
});
export const exampleH2Data = [
    {
        data: {
            user: {
                name: "Clinician",
                email: "david@clinician.com",
                address: "Clinician Address",
                postalCode: "ABC 123",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: true,
            },
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            hospital: {
                name: "Hospital",
                address: "Hospital Address",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
            registeredNurseIn: "sub-part1-mental-health-nursing",
        },
    },
];
//# sourceMappingURL=h2.js.map